// extracted by mini-css-extract-plugin
module.exports = {"dialogHeader":"styles_dialogHeader__1tYWT","dialogContent":"styles_dialogContent__wY4GL"};